import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * Hotspot - Affiche des éléments à des moments spécifiques de la vidéo
 */
export default class Hotspot extends Base {
  breakpoints = ['xxs', 'xs', 's'];

  /**
   * Component Configuration
   */
  static config = {
    name: 'Hotspot',
    refs: ['btn', 'content', 'close'],
    emits: ['click-btn'],
  };

  /**
   *
   */
  mounted() {
    if (!this.isMobile) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.onEnterViewport();
          } else {
            this.onExitViewport();
          }
        },
        { threshold: 0.2 },
      );
      this.observer.observe(this.$refs.content);
    }
  }

  /**
   *
   */
  onEnterViewport() {
    this.$refs.btn.classList.add('active');
  }

  /**
   *
   */
  onExitViewport() {
    this.$refs.btn.classList.remove('active');
  }

  /**
   * Click on btn
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onBtnClick({ target }) {
    if (this.isMobile) {
      this.$el.classList.remove('pointer-events-none');
      gsap.fromTo(
        this.$refs.content,
        {
          autoAlpha: 0,
          y: 20,
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          ease: 'power4.out',
        },
      );
      return;
    }
    this.$emit('click-btn', target.dataset.id);
  }

  /**
   *
   */
  onCloseClick() {
    this.$el.classList.add('pointer-events-none');
    gsap.to(this.$refs.content, {
      autoAlpha: 0,
      y: 20,
      duration: 0.5,
      ease: 'power4.out',
    });
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }
}
